import * as NewActions from './new.actions';

export interface State {
  storyUploading: boolean;
  submitting: boolean;
  mouseLeaved: boolean;
  warningMessageClosed: boolean;
  uploadingProjectId: string | null;
  uploadingProjectTitle: string | null;
  isProjectUpdating: boolean;
  uploadStatus: UploadStatus;
}

export interface UploadStatus {
  thumbnailPercent: number;
  thumbnailCounter: string;
  thmbStatus: string;
  progressPercent: number;
  progressCounter: string;
  status: string;
}

const initialState: State = {
  storyUploading: false,
  submitting: false,
  mouseLeaved: false,
  warningMessageClosed: false,
  uploadingProjectId: null,
  uploadingProjectTitle: null,
  isProjectUpdating: false,
  uploadStatus: {
    thumbnailPercent: -1,
    thumbnailCounter: '',
    thmbStatus: 'initial',
    progressPercent: -1,
    progressCounter: '',
    status: 'initial',
  },
};

export function NewReducer(
  state: State = initialState,
  action: NewActions.NewActions
) {
  switch (action.type) {
    case NewActions.INIT_UPLOAD:
      return {
        ...initialState,
      };
    case NewActions.START_UPLOAD:
      return {
        ...state,
        storyUploading: true,
      };
    case NewActions.SET_PROJECT_ID:
      return {
        ...state,
        uploadingProjectId: action.payload,
      };
    case NewActions.SET_PROJECT_TITLE:
      return {
        ...state,
        uploadingProjectTitle: action.payload,
      };
    case NewActions.SET_IS_PROJECT_UPDATING:
      return {
        ...state,
        isProjectUpdating: action.payload,
      };
    case NewActions.UPDATE_STATUS:
      return {
        ...state,
        uploadStatus: {
          ...action.payload,
        },
      };
    case NewActions.UPDATE_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };
    case NewActions.MOUSE_LEAVED:
      return {
        ...state,
        mouseLeaved: true,
      };
    case NewActions.WARNING_MESSAGE_CLOSED:
      return {
        ...state,
        warningMessageClosed: true,
      };
    default:
      return state;
  }
}
